module.exports = __webpack_public_path__ + "img/1236.737d5bae.gif";